import { FC } from 'react'
import { useSwiper } from 'swiper/react'

interface DotsComponentProps {
  photos: string[]
  indexActive: number
}

export const DotsComponent: FC<DotsComponentProps> = ({
  photos,
  indexActive
}) => {
  const swiper = useSwiper?.()

  const handleOnClick = (index: number) => {
    if (!swiper.destroyed) {
      swiper?.slideTo?.(index)
    }
  }

  return (
    <div
      data-testid="dots-component"
      className="w-full h-4 absolute bottom-5 left-0 flex justify-center items-center z-[3]"
    >
      <div className="flex gap-2 transition-all">
        {photos?.map((photo, index) => (
          <div
            data-testid="buttons"
            key={photo + index}
            onClick={() => handleOnClick(index)}
            onKeyDown={() => handleOnClick(index)}
            className="h-2 rounded-full transition-all duration-150 ease-linear"
            style={{
              width: index === indexActive ? '6rem' : '1.5rem',
              backgroundColor: index === indexActive ? '#d9d9d9' : '#d9d9d99e'
            }}
          />
        ))}
      </div>{' '}
    </div>
  )
}

export default DotsComponent
